export const INVERSE_BUTTON =
  'cursor-pointer border border-solid border-primary-main text-primary-main active:bg-primary-main active:text-white sm:hover:bg-primary-main sm:hover:text-white';
export const INVERSE_BUTTON_WHITE =
  'cursor-pointer border border-solid border-white text-white active:bg-white active:text-primary-main sm:hover:bg-white sm:hover:text-primary-main';
export const INVERSE_BUTTON_WHITE_DARK_MODE =
  'cursor-pointer border border-solid border-white text-white active:bg-white active:text-primary-light sm:hover:bg-white sm:hover:text-primary-light';
export const INVERSE_BUTTON_GRAY =
  'cursor-pointer border border-solid border-base-lighter text-base-lighter active:bg-primary-main active:text-white sm:hover:bg-primary-main sm:hover:text-white';
export const INVERSE_BUTTON_GRAY_DARK_MODE =
  'cursor-pointer border border-solid border-base-lighter text-base-lighter active:border-primary-light active:bg-primary-light active:text-white sm:hover:border-primary-light sm:hover:bg-primary-light sm:hover:text-white';
export const INVERSE_BUTTON_DARK_MODE =
  'cursor-pointer border border-solid border-primary-lighter text-primary-lighter active:bg-primary-light active:border-primary-light active:text-white sm:hover:bg-primary-light sm:hover:border-primary-light sm:hover:text-white';

export const INVERSE_BUTTON_DISABLED =
  'cursor-default border border-solid border-gray-dark text-gray-dark opacity-36 pointer-events-none';
export const INVERSE_BUTTON_WHITE_DISABLED =
  'cursor-default border border-solid border-white text-white opacity-28 pointer-events-none';
export const INVERSE_BUTTON_DARK_MODE_DISABLED =
  'cursor-default border border-solid border-gray-dark-56 text-gray-dark-56 pointer-events-none';

export default {
  default: INVERSE_BUTTON,
  white: INVERSE_BUTTON_WHITE,
  'white-dark': INVERSE_BUTTON_WHITE_DARK_MODE,
  gray: INVERSE_BUTTON_GRAY,
  'gray-dark': INVERSE_BUTTON_GRAY_DARK_MODE,
  darkMode: INVERSE_BUTTON_DARK_MODE,
  'default-disabled': INVERSE_BUTTON_DISABLED,
  'white-disabled': INVERSE_BUTTON_WHITE_DISABLED,
  'gray-disabled': INVERSE_BUTTON_DISABLED,
  'darkMode-disabled': INVERSE_BUTTON_DARK_MODE_DISABLED,
};
